import { createFileRoute } from '@tanstack/react-router'
import { AlertHistoryPage } from '../../../features/alerts/AlertHistoryPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/alerts/history')({
  component: AlertHistoryPage,
})
